<template>
  <section>
    <div class="account-details-content">
      <div class="account-details-component col-1-2">
        <account-users @impersonate-modal="showImpersonateModal" />
      </div>
      <div class="account-details-component col-1-2">
        <acclaro-team @team-member-modal="showTeamMemberModal" />
      </div>
      <div class="account-details-component col-1-2">
        <email-preferences />
      </div>
      <div class="account-details-component col-1-2">
        <security />
      </div>
      <div class="account-details-component col-1-3">
        <translation-review />
      </div>
      <div class="account-details-component col-1-3">
        <reports />
      </div>
    </div>
    <add-team-member-modal @close="closeTeamMemberModal()" v-if="toggles.teamMemberModal" />
    <impersonate-modal
       v-if="impersonateModal.isActive"
       :user="impersonateModal.activeUser"
       @close="closeImpersonationModal"
    />
    <notifications group="admin:account:details" />
    <v-dialog />
  </section>
</template>

<script>
import './accounts.scss';

import AcclaroTeam from './AcclaroTeam.vue';
import AccountUsers from './AccountUsers.vue';
import AddTeamMemberModal from './AddTeamMemberModal.vue';
import EmailPreferences from './EmailPreferences.vue';
import impersonateModal from '../Datatables/components/impersonateModal';
import Reports from './Reports.vue';
import Security from './Security.vue';
import AccountNav from './AccountNav.vue';
import TranslationReview from './TranslationReview.vue';
import { mapActions, mapGetters } from "vuex";


export default {

  props: {

    accountId: {
      type: [Number, String],
      required: true
    },

    accountName: {
      type: String,
      required: true,
    },

    isProgramMandatory: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    AcclaroTeam,
    AccountUsers,
    EmailPreferences,
    Reports,
    Security,
    TranslationReview,
    AccountNav,
    impersonateModal,
    AddTeamMemberModal,
  },

  beforeMount () {
    //get Account data
    this.getAccount(this.accountId).then(result => {
        //console.log('the account data', result);
    })

    //get team data for the account
    this.loadTeamData(this.accountId).then(result => {
        //console.log('the team data', result);
    })

    //get email preference data
    this.loadEmailPreferenceData(this.accountId).then(result => {
        //console.log('the email prefs', result);
    });

    //get account multi factor authentication settings
    this.loadMfaSettingsData(this.accountId).then(result => {
       //console.log('mfasettings', result);
    });

    //get TRM enabled/disabled setting
    this.loadTRMPreferencesData(this.accountId).then(result => {
        //console.log('trm prefs data', result);
    })

    //get kibaana reports data
    this.loadKibanaReportsData(this.accountId).then(result => {
        //console.log('kibana reports data', result)
    })

    //get account users data
    this.loadAccountUsers(this.accountId).then(result => {
        //console.log('the account users', result);
    })
  },

  mounted () {
    console.log('mounted acclaro');
  },

  data () {

    return {
        impersonateModal: {
            isActive: false,
            activeUser: {}
        },

        toggles: {
          teamMemberModal: false,
        }
    }
  },

  computed: {
    ...mapGetters('AdminAccountDetailsStore', [
        'account'
    ]),
  },

  methods: {

    ...mapActions('AdminAccountDetailsStore', [
        'getAccount',
        'loadEmailPreferenceData',
        'loadMfaSettingsData',
        'loadTRMPreferencesData',
        'loadKibanaReportsData',
        'loadAccountUsers'
    ]),

    ...mapActions('AdminAccountDetailsTeamStore', [
        'loadTeamData'
    ]),

    showTeamMemberModal () {
      this.toggles.teamMemberModal = true;
    },

    closeTeamMemberModal () {
      this.toggles.teamMemberModal = false;
    },

      showImpersonateModal (payload) {
          let {user} = payload;

          this.impersonateModal.isActive = true;
          this.impersonateModal.activeUser = user;
      },

      closeImpersonationModal () {
          this.impersonateModal.isActive = false;
      },
  }
}
</script>
